<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <h1>{{ currentOrg.name }} Users</h1>

      <form (ngSubmit)="search()" style="width: 100%">
        <div class="ui-g filterPanel form-group">
          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <span class="md-inputfield filterItem">
              <input
                name="Email"
                type="text"
                pInputText
                [(ngModel)]="filterVal.filters.email.value"
              />
              <label>Email</label>
            </span>
          </div>

          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <span class="md-inputfield filterItem">
              <input
                name="FirstName"
                type="text"
                pInputText
                [(ngModel)]="filterVal.filters.firstName.value"
              />
              <label>First Name</label>
            </span>
          </div>

          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <span class="md-inputfield filterItem">
              <input
                name="LastName"
                type="text"
                pInputText
                [(ngModel)]="filterVal.filters.lastName.value"
              />
              <label>Last Name</label>
            </span>
          </div>

          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <div class="md-inputfield filterItem">
              <select pInputText name="Status" [(ngModel)]="filterVal.filters.isActive.value">
                <option value="null">Enabled + Disabled Users</option>
                <option value="true">Enabled</option>
                <option value="false">Disabled</option>
              </select>
            </div>
          </div>

          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <button pButton type="submit" label="Search"></button>
            <button pButton type="button" label="Clear" (click)="clearFilter(dataTable)"></button>
          </div>
        </div>
      </form>

      <p-table
        #dataTable
        [value]="page?.items"
        [lazy]="true"
        [rows]="10"
        [paginator]="true"
        [totalRecords]="page?.total"
        (onLazyLoad)="onGridLazyLoad($event)"
        rowHover="true"
        selectionMode="single"
        [(selection)]="selectedUser"
        (onRowSelect)="highlight()"
        (onRowUnselect)="hideImpersonate()"
        [loading]="isLoading"
        [hidden]="!page"
        [sortField]="filterVal.sortField"
        [sortOrder]="filterVal.sortOrder"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="email">E-mail</th>
            <th pSortableColumn="firstName">First Name</th>
            <th pSortableColumn="lastName">Last Name</th>
            <th pSortableColumn="isLockedOut">User Status</th>
            <th *ngIf="currentOrg?.organisationTypeId === 3">Emergency Contact?</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item" (dblclick)="editUser(item)">
            <td style="overflow-x: hidden">{{ item.email }}</td>
            <td>{{ item.firstName }}</td>
            <td>{{ item.lastName }}</td>
            <td style="text-align: center">
              {{ item.isLockedOut ? 'Disabled' : 'Enabled' }}
            </td>
            <td *ngIf="currentOrg?.organisationTypeId === 3">
              {{ item.hasEmergencyContact ? 'Yes' : 'No' }}
            </td>
          </tr>
        </ng-template>
      </p-table>
      <!-- DATATABLE DEPRECATED --
      <p-dataTabl #dataTable [value]="page.items" [lazy]="true" [editabl]="true" [rows]="10" [paginator]="true"
                   [totalRecords]="page.total"
                   (onLazyLoad)="onGridLazyLoad($event)" rowHover="true" selectionMode="single"
                   [(selection)]="selectedUser"
                   (click)="highlight()">
        (onRowDblclick)="editUser($event.data)" [responsive]="true">
        <p-column field="email" header="Email" [sortable]="tru"></p-column>
        <p-column field="firstName" header="First Name" [sortable]="tru"></p-column>
        <p-column field="lastName" header="Last Name" [sortable]="tru"></p-column>
        <p-column field="isLockedOut" header="User Status" [sortable]="tru" [editable]="false"
                  [style]="{'width':'130px'}">
          <ng-template let-user="rowData" pTemplate="body">
            {{ user.isLockedOut ? 'Disabled' : 'Enabled' }}
          </ng-template>
        </p-column>
        <p-column field="isAdmin" header="Admin" [style]="{'width':'70px','text-align':'center'}">
          <ng-template let-user="rowData" pTemplate="body">
            <i class="fa fa-check" *ngIf="isAdmin(user)"></i>
          </ng-template>
        </p-column>
      </p-dataTable>
      -->

      <div class="footerPanel ui-grid-row" *ngIf="page">
        <button
          *ngIf="backTo || isActiveCheckList"
          type="button"
          (click)="close()"
          class="btn-to-right"
          icon="fa ui-icon-close"
          pButton
          label="Close"
        ></button>
        <button
          type="button"
          pButton
          (click)="lockUnlockUser(selectedUser)"
          [label]="selectedUser && selectedUser.isLockedOut ? 'Enable' : 'Disable'"
          [ngClass]="
            selectedUser && selectedUser.isLockedOut
              ? 'btn-to-right ui-button-success'
              : 'btn-to-right ui-button-danger'
          "
          [disabled]="!selectedUser"
        ></button>
        <button
          type="button"
          pButton
          class="btn-to-right"
          (click)="resetUser2FA(selectedUser)"
          label="Reset 2FA"
          [disabled]="!selectedUser"
          *ngIf="currentOrg && currentOrg.organisationTypeId == 1 && canReset2FA()"
        ></button>
        <button
          type="button"
          class="btn-to-right"
          pButton
          icon="fa ui-icon-edit"
          (click)="editUser(selectedUser)"
          label="Edit"
          [disabled]="!selectedUser"
        ></button>
        <button
          type="button"
          class="btn-to-right"
          pButton
          icon="fa ui-icon-add"
          (click)="addUser()"
          label="Add"
        ></button>
        <button
          [disabled]="!selectedUser"
          type="button"
          (click)="emergencyContact()"
          class="btn-to-right"
          icon="fa ui-icon-person"
          pButton
          label="Emergency Contact"
          *ngIf="currentOrg?.organisationTypeId === 3"
        ></button>
        <button
          type="button"
          pButton
          label="Impersonate User"
          [disabled]="!enableImpersonateButton"
          *ngIf="!hideImpersonateButton"
          class="ui-button green-btn pull-right mt-1 ui-sm-12"
          icon="fa ui-icon-person"
          (click)="impersonate()"
        ></button>
      </div>

      <span *ngIf="isLoading && !page">
        <span class="loading-notice">
          <i class="fa fa-spin fa-2x fa-spinner"></i>
          Loading
        </span>
      </span>
    </div>
  </div>
</div>

<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Save"
  rejectLabel="Cancel"
></p-confirmDialog>
